module.exports = __webpack_public_path__ + "5659c7347054cca0bd8a0aa636a2fa0d.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_medium_x1/public/history/fi-2013.png
// module id = 387
// module chunks = 0